import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { getEnvironmentFromUrl, LD_CLIENT_IDS } from './utils/helper';

// Derive environment from URL or build-time config
const currentEnv = getEnvironmentFromUrl();

const ldClientId = LD_CLIENT_IDS[currentEnv];

asyncWithLDProvider({
  clientSideID: ldClientId,
  user: {
    key: 'hpsmart-user',
    anonymous: true
  }
}).then((LDProvider) => {
  ReactDOM.render(
    <React.StrictMode>
      <LDProvider>
        <App currentStack={currentEnv} />
      </LDProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );

  serviceWorker.unregister();
});
